import request from '../../util/studentCenter/spadRequest';
import { getSpadSign, getStamp, getRandom } from '@/util/studentCenter/index';

let BASE_URL = '/api';
// if (window.location.href.indexOf('activateSimp') > -1) {
//   BASE_URL = 'https://crm-schoolm-api.myyixue.com/api';
// } else
if ((window.location.port > 3000 || window.location.href.indexOf('exp4pad-test.classba.cn')) !== -1) {
  BASE_URL = 'https://agent-api-test.classba.cn/agentmanageapi/api';
  // BASE_URL = 'https://test-agent-manage-api.myyixue.com/api';
  // BASE_URL = 'http://192.168.31.105:8088/api';
  // BASE_URL = 'http://agent-api.zc.dev.myyixue.com/agentmanageapi/api';

  // BASE_URL = 'https://crm-schoolm-api.songshuai.com/api';
} else if (window.location.href.indexOf('exp4pad.classba.cn') > -1) {
  BASE_URL = 'https://agent-api.classba.cn/agentmanageapi/api';
} else if (window.location.href.indexOf('exp4pad-pre.classba.cn') > -1) {
  // https://agent-manage-api-pre.songshuai.com/api/c/machine/checkSnCodeAuthPhone
  BASE_URL = 'https://agent-manage-api-pre.songshuai.com/api';
}
// https://m-pre.songshuai.com/activateSimp/?phone=13700080008&sn=X10024006B
// BASE_URL = '/agentmanageapi/api';
/**
 * 获取设备帐户信息
 */
const getMachineAccountInfo = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/machine/getMachineAccountInfo',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * 激活设备账号信息
 */
const machineActivation = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/machine/machineActivation',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * 登录
 */
const subuserAccountLoginmit = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/machine/userAccountLogin',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * 账户绑定学员学习账号
 */
const bindUserAccount = (data) => {
  const { latitude, longitude } = JSON.parse(sessionStorage.getItem('queryInfo') || '{}');
  if (data.parm) {
    data.parm = {
      ...data.parm,
      lat: latitude,
      lon: longitude,
    };
  } else {
    data = {
      ...data,
      lat: latitude,
      lon: longitude,
    };
  }
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/machine/bindUserAccount',
    method: 'post',
    data: params,
  });
};
/**
 * 订阅学科
 */
const subscriptionSubject = (data) => {
  const { latitude, longitude } = JSON.parse(sessionStorage.getItem('queryInfo') || '{}');
  if (data.parm) {
    data.parm = {
      ...data.parm,
      lat: latitude,
      lon: longitude,
    };
  } else {
    data = {
      ...data,
      lat: latitude,
      lon: longitude,
    };
  }
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/machine/subscriptionSubject',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * 发送验证码
 */
const getValidateCode = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/msg/getValidateCode',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * 校验验证码
 */
const checkValidateCode = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/msg/checkValidateCode',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * 城市列表
 */
const getProvinceCity = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/base/area/' + data.selectId,
    method: 'get',
    data: JSON.stringify(params),
  });
};

/**
 * 学校列表
 */
const getBaseSchools = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/school/getBaseSchools',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * 取消订阅
 */
const unSubscribe = (data) => {
  const { latitude, longitude } = JSON.parse(sessionStorage.getItem('queryInfo') || '{}');
  if (data.parm) {
    data.parm = {
      ...data.parm,
      lat: latitude,
      lon: longitude,
    };
  } else {
    data = {
      ...data,
      lat: latitude,
      lon: longitude,
    };
  }
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/machine/unSubscribe',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * 取消退订
 */
const cancelUnSubscribe = (data) => {
  const { latitude, longitude } = JSON.parse(sessionStorage.getItem('queryInfo') || '{}');
  if (data.parm) {
    data.parm = {
      ...data.parm,
      lat: latitude,
      lon: longitude,
    };
  } else {
    data = {
      ...data,
      lat: latitude,
      lon: longitude,
    };
  }
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/machine/cancelUnSubscribe',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * 注册
 */
const userRegister = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/machine/userRegister',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * 校验手机号
 */
const checkUserRegister = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/machine/checkUserRegister',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * 修改区域
 */
const modifyCity = (data) => {
  const { latitude, longitude } = JSON.parse(sessionStorage.getItem('queryInfo') || '{}');
  if (data.parm) {
    data.parm = {
      ...data.parm,
      lat: latitude,
      lon: longitude,
    };
  } else {
    data = {
      ...data,
      lat: latitude,
      lon: longitude,
    };
  }
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/certificate/modifyCity',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * 订阅学习时长记录
 */
const getHoursDetails = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/machine/getHoursDetails',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * 获取折算后学习时长
 */
const getConversionHours = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/certificate/getConversionHours',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * 查询我的服务中心
 */
const queryServicepoint = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    // baseURL: BASE_URL + '/manage/machine/queryServicepoint', // 以前接口地址
    baseURL: BASE_URL + '/c/machine/queryServicePointList', // 新接口
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * 查询更换服务中心次数
 */
const queryStudentTransferTimes = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/queryStudentTransferTimes',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * 学员确认转校
 */
const studentTransferSchool = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/studentTransferSchool',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * 获取默认城市
 */
const queryAccountCertificateInfo = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/queryAccountCertificateInfo',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * 查询我的服务中心
 */
const queryMyServicepoint = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/machine/queryMyServicepoint',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * 查询服务中心
 */
const queryMyService = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/queryMyService',
    method: 'post',
    data: JSON.stringify(params),
  });
};
const queryMyServiceForH5 = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/queryMyServiceForH5',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * 申请转服务中心
 */
const transferSchoolApply = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/transferSchoolApply',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * 取消转服务中心
 */
const cancelTaskC = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/cancelTask',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * 审核转服务中心
 */
const auditTask = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/auditTask',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * 转校
 */
const studentSchoolChange = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/machine/studentSchoolChange',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * 取消转校
 */
const cancelTask = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/machine/cancelTask',
    method: 'post',
    data: JSON.stringify(params),
  });
};

// 学习机激活流程简化activateSimp
/**
 * c端获取设备和授权手机号激活状态信息
 */
const checkSnCodeAuthPhone = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/checkSnCodeAuthPhone',
    method: 'post',
    data: JSON.stringify(params),
  });
};

// 学习机激活流程简化activateSimp
/**
 * 记录操作日志
 */
const addFeLog = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/feLog',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * 获取单独手机号、SN 码
 */
const queryAccountSnMobile = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/queryAccountSnMobile',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * c端账号注册
 */
const clientRegister = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/clientRegister',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * c端完善账号信息
 */
const updateUserInfo = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/updateUserInfo',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * c端获取省份城市对应的学习时长配置信息
 */
const getHoursConfigByCity = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/getHoursConfigByCity',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * c端订阅学科
 */
const subscriptionSubjectC = (data) => {
  const { latitude, longitude } = JSON.parse(sessionStorage.getItem('queryInfo') || '{}');
  if (data.parm) {
    data.parm = {
      ...data.parm,
      lat: latitude,
      lon: longitude,
    };
  } else {
    data = {
      ...data,
      lat: latitude,
      lon: longitude,
    };
  }
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/subscriptionSubject',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * c端账户激活（创建账户）
 */
const clientAccountActivation = (data) => {
  const { latitude, longitude } = JSON.parse(sessionStorage.getItem('queryInfo') || '{}');
  if (data.parm) {
    data.parm = {
      ...data.parm,
      lat: latitude,
      lon: longitude,
    };
  } else {
    data = {
      ...data,
      lat: latitude,
      lon: longitude,
    };
  }
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/clientAccountActivation',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * c端验证学员转入
 */
const checkMoveTo = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/checkMoveTo',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * c端验证学员转入
 */
const studentMove = (data) => {
  const { latitude, longitude } = JSON.parse(sessionStorage.getItem('queryInfo') || '{}');
  if (data.parm) {
    data.parm = {
      ...data.parm,
      lat: latitude,
      lon: longitude,
    };
  } else {
    data = {
      ...data,
      lat: latitude,
      lon: longitude,
    };
  }
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/studentMove',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * c端验证学员退订
 */
const checkCanGiftHour = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/machine/checkCanGiftHour',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * c端账户绑定学员帐号信息列表
 */
const getBindUserListByAccountV2 = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/getBindUserListByAccountV2',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * c端获取学习帐号订阅信息
 */
const getBindUserSubscribeList = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/getBindUserSubscribeList',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * c端获取当前学习机账户常用地不为空且与认证区域是否一致
 */
const getOftenUseCityAndCertificateCity = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/getOftenUseCityAndCertificateCity',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * c端获取账户及消费信息
 */
const getLearningAccountHours = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/getLearningAccountHours',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * c端根据手机号查询账号列表
 */
const getUserListByPhone = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/getUserListByPhone',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 * c端根据手机号查询账号列表
 */
const getUserAccountSubscribeV2 = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/manage/machine/getUserAccountSubscribeV2',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 * c端根据手机号查询账号列表
 */
const updateUserPassword = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/updateUserPassword',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**

 *  查询转入申请 - 由代理商发起
 */
const queryTransApplyInfo = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/queryTransApplyInfo',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 *  转入申请确认操作
 */
const transferApplyConfirm = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/transferApplyConfirm',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 *  转入申请确认操作
 */
const queryAuthManageList = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/queryAuthManageList',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 *  获取订阅授权申请
 */
const queryAuthApplyInfo = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/queryAuthApplyInfo',
    method: 'post',
    data: JSON.stringify(params),
  });
};
/**
 *  确认授权申请
 */
const authApplyConfirm = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/authApplyConfirm',
    method: 'post',
    data: JSON.stringify(params),
  });
};

/**
 *  退出或者转换时提示是否可以退出或者转换
 */
const checkstudenttransferlimit = (data) => {
  const params = data;
  params.time = getStamp();
  params.sign = getSpadSign();
  return request({
    baseURL: BASE_URL + '/c/machine/checkstudenttransferlimit',
    method: 'post',
    data: JSON.stringify(params),
  });
};

export {
  getMachineAccountInfo,
  machineActivation,
  subuserAccountLoginmit,
  bindUserAccount,
  subscriptionSubject,
  getValidateCode,
  checkValidateCode,
  getProvinceCity,
  getBaseSchools,
  unSubscribe,
  cancelUnSubscribe,
  userRegister,
  checkUserRegister,
  modifyCity,
  getHoursDetails,
  getConversionHours,
  queryServicepoint,
  queryStudentTransferTimes,
  studentTransferSchool,
  queryAccountCertificateInfo,
  queryMyServicepoint,
  queryMyService,
  queryMyServiceForH5,
  studentSchoolChange,
  cancelTask,
  cancelTaskC,
  transferSchoolApply,
  checkSnCodeAuthPhone,
  addFeLog,
  auditTask,
  clientRegister,
  updateUserInfo,
  getHoursConfigByCity,
  subscriptionSubjectC,
  clientAccountActivation,
  getBindUserListByAccountV2,
  getBindUserSubscribeList,
  getOftenUseCityAndCertificateCity,
  getLearningAccountHours,
  getUserListByPhone,
  checkMoveTo,
  studentMove,
  checkCanGiftHour,
  getUserAccountSubscribeV2,
  updateUserPassword,
  queryTransApplyInfo,
  queryAccountSnMobile,
  transferApplyConfirm,
  queryAuthManageList,
  authApplyConfirm,
  queryAuthApplyInfo,
  checkstudenttransferlimit,
};
